export function calculateETA(
	currentProgress: number,
	totalItems: number,
	startTime: number,
	lastUpdateTime: number,
  lastEtaText: string
): { etaText: string; newLastUpdateTime: number } {
	const now = Date.now();
	const elapsed = now - startTime;
	const progress = currentProgress / totalItems;

	// Only calculate ETA if we have at least 1% progress and it's been at least 1 second since last update
	if (progress <= 0.01 || now - lastUpdateTime < 1000) {
		return {
      etaText: lastEtaText,
      newLastUpdateTime: lastUpdateTime,
    };
	}

	const totalEstimated = elapsed / progress;
	const remaining = totalEstimated - elapsed;
	const remainingSeconds = Math.ceil(remaining / 1000);

	let etaText: string;
	if (remainingSeconds > 60) {
		const minutes = Math.floor(remainingSeconds / 60);
		const seconds = remainingSeconds % 60;
		etaText = ` - ETA: ${minutes}m ${seconds}s`;
	} else {
		etaText = ` - ETA: ${remainingSeconds}s`;
	}

	return {
		etaText,
		newLastUpdateTime: now,
	};
}
